define([
	'jquery',
	'underscore',
	'backbone',
	'view/global',
	'nougat',
	'constants',
	'routes/activity',
	'routes/transaction',
	'routes/wallet',
	'routes/summary'
], function ($, _, Backbone, GlobalPageView, nougat, constants, ActivityRoute, TransactionRoute, WalletRoute, SummaryRoute) {

	'use strict';

	return Backbone.Router.extend({

		/* Detect if the browser supports HTML5 push state */
		hasPushState: window.history && 'pushState' in window.history,

		/**
		 * Register all the interesting URIs that will fire off generic or specific functionality
		 */
		routes: {
			'activity(/*subroute)': 'invokeActivity',
			'transaction(/*subroute)': 'invokeTransaction',
			'wallet(/*subroute)': 'invokeWallet',
			':home(/*subroute)': 'invokeSummary',
			'(/*subroute)': 'invokeSummary',
			'': 'invokeSummary'

			/* No generic route to avoid downloading/initializing JS files that do not exist */
		},

		/**
		 * Important setup to start using the router.
		 */
		initialize: function() {
			// Get current fragment or current path for route for non pushState browsers
			var hash = window.location.hash,
				fragment = (hash && hash.length === 0) ? hash : window.location.pathname.substr(constants.ROOT.length);

			// set the default templates path depending on the value from json contract
			nougat.setContext($(document.body).data());

			this.globalPageView = new GlobalPageView();

			Backbone.history.start({
				silent: true, // Add hashUrl before executing the route for IE
				pushState: this.hasPushState, // Use HTML5 Push State if it's supported
				root: constants.ROOT // Initial path for app
			});

			// Load the initial route, using pushstate if supported, hashUrl if not
			if (this.hasPushState) {
				Backbone.history.loadUrl(Backbone.history.getFragment());
			} else {
				var rootLength = Backbone.history.options.root.length;
				// Get current fragment or current path for route for non pushState browsers
				fragment = window.location.hash || window.location.pathname.substr(rootLength);

				// Clear the history for IE for refreshing the page
				Backbone.history.fragment = null;
				$(window).scrollTop();

				Backbone.history.navigate(fragment, { trigger: true, replace: true });
			}
		},

		invokeActivity: function () {
			if (!this.ActivityRoute) {
				this.ActivityRoute = new ActivityRoute('activity', {createTrailingSlashRoutes: true});
			}
		},

		invokeTransaction: function () {
			if (!this.TransactionRoute) {
				this.TransactionRoute = new TransactionRoute('transaction', {createTrailingSlashRoutes: true});
			}
		},

		invokeWallet: function () {
			if (!this.WalletRoute) {
				this.WalletRoute = new WalletRoute('wallet', {createTrailingSlashRoutes: true});
			}
		},

		/**
		 *	Show summary for /myaccount/home if module === home or /myaccount
		 *	@param module - either undefined or home to show summary
		 */
		invokeSummary: function () {
			var pathname;
			if (!this.SummaryRoute) {
				// If we're at the default root, replace URL to /home.
				pathname = window.location && window.location.pathname;
				if (pathname && (pathname === '/myaccount' || pathname === '/myaccount/')) {
					Backbone.history.navigate('/home');
				}
				this.SummaryRoute = new SummaryRoute('home', {createTrailingSlashRoutes: true});
			}
		}
	});

});



//////////////////
// WEBPACK FOOTER
// ./router.js
// module id = 6
// module chunks = 0